import React from 'react';
import {observer} from 'mobx-react';
import {Box} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import FormSection from '../../../forms/FormSection';
import FormAutocompleteMultipleSelectField from '../../../components/fields/FormAutocompleteMultipleSelectField';
import FormSetPanel from '../../../components/FormSetPanel';
import useFeature from '../../../useFeature';
import {useApplication} from '../../../ApplicationProvider';
import FormSkeleton from "../../../components/FormSkeleton";
import FormRow from "../../../forms/FormRow";
import FormTextField from "../../../components/fields/FormTextField";
import FormColumn from "../../../forms/FormColumn";
import CompletionProgressBar from "../../../components/CompletionProgressBar";
import AlertNotification from "../../../components/notifications/AlertNotification";

function UsersPanel({ generalFeature }) {
    const application = useApplication();
    const feature = useFeature(() => generalFeature.features['CustomerOnboardingNewUsersFeature'])

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const renderUserContent = (user) => {
        return (
            <>
            <Box mb={2}>
                <CompletionProgressBar form={user} />
            </Box>
            <FormSection>
                <FormColumn>
                    <FormRow>
                        <FormTextField
                            label="Email"
                            form={user}
                            fieldName="email"
                        />
                        <FormAutocompleteMultipleSelectField
                            label={'Puntos de entrega asignados'}
                            form={user}
                            fieldName={'deliverySiteOnboardingRequests'}
                            options={feature.deliverySitesFieldOptions()}
                        />
                        <FormAutocompleteMultipleSelectField
                            label={'Roles'}
                            form={user}
                            fieldName={'roles'}
                            options={feature.rolesFieldOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
            </>
        )
    };

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton
                rows={3}
                fieldsPerRow={3}
            />
        );
    }

    return (
        <Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={feature.usersFormSet} />
            {!feature.hasAUserWithMarketplaceAdministratorRole() &&
                <AlertNotification message="Debe haber al menos un usuario con rol Administrador Marketplace para poder avanzar." />
            }
            <FormSetPanel
                formSet={feature.usersFormSet}
                addButtonTitle="Agregar Usuario"
                addButtonIcon={<PersonAddIcon fontSize="small"/>}
                onAddItem={() => feature.addUser()}
                onRemoveItem={(userId) => feature.removeUser(userId)}
                renderItemContent={renderUserContent}
                getItemTitle={(user) => user.email() || 'Nuevo usuario'}
                emptyStateTitle="No hay usuarios agregados"
                emptyStateDescription="Haz clic en 'Agregar Usuario' para comenzar"
                emptyStateIcon={<PersonAddIcon />}
                disabled={!feature.canEditUserOnboardingRequests()}
            />
        </Box>
    );
}

export default observer(UsersPanel);